/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CreateGeneralFeedbackRequest = {
    issueType?: CreateGeneralFeedbackRequest.issueType;
    details: string;
};

export namespace CreateGeneralFeedbackRequest {

    export enum issueType {
        NOT_CORRECT = 'not_correct',
        UNFOLLOW_INSTRUCTIONS = 'unfollow_instructions',
        OTHER = 'other',
    }


}

